var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2447 7.92344C28.2299 8.34303 27.1588 8.6108 26.066 8.71813C27.1661 8.04308 28.0062 7.01636 28.45 5.8043C27.3856 6.43786 26.2211 6.88573 25.0064 7.12876C24.5299 6.57977 23.9393 6.14131 23.276 5.84394C22.6126 5.54657 21.8924 5.39745 21.1655 5.40696C20.4603 5.39543 19.7598 5.52362 19.1044 5.78414C18.449 6.04466 17.8517 6.43236 17.3468 6.92487C16.842 7.41738 16.4397 8.00495 16.1631 8.65372C15.8865 9.30248 15.741 9.99959 15.7351 10.7048C15.7136 11.1067 15.7583 11.5095 15.8676 11.8968C13.7722 11.8311 11.7161 11.3116 9.84105 10.3741C7.96601 9.43656 6.31669 8.10338 5.00693 6.46653C4.45081 7.23459 4.17075 8.16813 4.21225 9.11547C4.21913 10.0023 4.43935 10.8745 4.85429 11.6583C5.26924 12.4421 5.86674 13.1145 6.5963 13.6187C5.76134 13.4949 4.95449 13.226 4.21225 12.824V12.9565C4.13861 14.1724 4.51719 15.3725 5.27516 16.3261C6.03312 17.2797 7.11694 17.9193 8.3181 18.1219C7.84167 18.2377 7.3507 18.2824 6.86119 18.2543C6.50286 18.2758 6.14365 18.2309 5.80162 18.1219C6.13729 19.1948 6.80622 20.1328 7.71128 20.7997C8.61634 21.4666 9.71041 21.8276 10.8346 21.8304C8.89808 23.315 6.51984 24.1078 4.07984 24.082C3.63423 24.1037 3.18787 24.059 2.75537 23.9496C5.53169 25.8031 8.82344 26.7303 12.159 26.5984C22.0925 26.5984 26.5957 18.3867 26.5957 11.3671V10.7048C27.6416 9.94779 28.5395 9.00501 29.2447 7.92344Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fc9bef63b6b40d9c4a71b19493cd0123.svg";
export { ForwardRef as ReactComponent };